{
  "show_fraud_detected_message_modal": {
    "title": "Possible fraud detected",
    "body": "The message you have received is possibly a phishing message, would you want to see it anyway?"
  },
  "whatsapp_business_api_agent_page": {
    "template_langs": {
      "af": "Afrikaans",
      "sq": "Albanian",
      "ar": "Arabic",
      "az": "Azerbaijani",
      "bn": "Bengali",
      "bg": "Bulgarian",
      "ca": "Catalan",
      "zh_CN": "Chinese (CHN)",
      "zh_HK": "Chinese (HKG)",
      "zh_TW": "Chinese (TAI)",
      "hr": "Croatian",
      "cs": "Czech",
      "da": "Danish",
      "nl": "Dutch",
      "en": "English",
      "en_GB": "English (UK)",
      "en_US": "English (US)",
      "et": "Estonian",
      "fil": "Filipino",
      "fi": "Finnish",
      "fr": "French",
      "ka": "Georgian",
      "de": "German",
      "el": "Greek",
      "gu": "Gujarati",
      "ha": "Hausa",
      "he": "Hebrew",
      "hi": "Hindi",
      "hu": "Hungarian",
      "id": "Indonesian",
      "ga": "Irish",
      "it": "Italian",
      "ja": "Japanese",
      "kn": "Kannada",
      "kk": "Kazakh",
      "rw_RW": "Kinyarwanda",
      "ko": "Korean",
      "ky_KG": "Kyrgyz (Kyrgyzstan)",
      "lo": "Lao",
      "lv": "Latvian",
      "lt": "Lithuanian",
      "mk": "Macedonian",
      "ms": "Malay",
      "ml": "Malayalam",
      "mr": "Marathi",
      "nb": "Norwegian",
      "fa": "Persian",
      "pl": "Polish",
      "pt_BR": "Portuguese (BR)",
      "pt_PT": "Portuguese (POR)",
      "pa": "Punjabi",
      "ro": "Romanian",
      "ru": "Russian",
      "sr": "Serbian",
      "sk": "Slovak",
      "sl": "Slovenian",
      "es": "Spanish",
      "es_AR": "Spanish (ARG)",
      "es_ES": "Spanish (SPA)",
      "es_MX": "Spanish (MEX)",
      "sw": "Swahili",
      "sv": "Swedish",
      "ta": "Tamil",
      "te": "Telugu",
      "th": "Thai",
      "tr": "Turkish",
      "uk": "Ukrainian",
      "ur": "Urdu",
      "uz": "Uzbek",
      "as": "Assamese",
      "hne": "Chhattisgarhi",
      "km": "Khmer",
      "mni_Mtei": "Meiteilon (Manipuri)",
      "or": "Odia",
      "ps": "Pashto",
      "so": "Somali",
      "vi": "Vietnamese",
      "yo": "Yoruba",
      "zu": "Zulu"
    },
    "upload_types": {
      "documents": "Documents",
      "photos_and_videos": "Photos & Videos",
      "camera": "Camera",
      "location": "Location"
    },
    "drop_files": "Drop files",
    "file_exeeds_limit": "Failed to upload file: {{fileName}}. File size exceeds the limit{{maxFileSize}}",
    "no_preview_available": "No preview available",
    "chats_filters_title": "FILTER CHATS",
    "phone": "Phone",
    "first_name": "First Name",
    "last_name": "Last Name",
    "save": "Save",
    "failed_to_start_new_chat": "Failed to start new chat. Please try again.",
    "failed_to_add_contact": "Failed to add contact. Please try again.",
    "failed_to_add_contact_phone_number_already_exists": "Unable to add contact: The phone number you provided already exists in our records. Please check the entered number for accuracy or consider updating the existing contact details.",
    "failed_to_add_contact_to_contacts": "Failed to add chat to contact. Please try again.",
    "failed_to_update_contact": "Failed to update contact. Please try again.",
    "failed_to_update_contact_phone_number_already_exists": "Unable to update contact: The phone number you entered already exists in our records. Please ensure the phone number is unique or consider editing the existing contact instead.",
    "failed_to_archive_contact": "Failed to archive contact. Please try again.",
    "failed_to_archive_chat": "Failed to archive chat. Please try again.",
    "failed_to_unarchive_contact": "Failed to unarchive contact. Please try again.",
    "failed_to_unarchive_chat": "Failed to unarchive chat. Please try again.",
    "failed_to_send_message": "Message failed to send. Please try again.",
    "empty_state_message": "Start chatting instantly by clicking on any chat",
    "contacts_empty_state_message": "Select a contact to begin managing your contacts list",
    "nav_options": {
      "chats": "Chats",
      "active_chats": "Active chats",
      "archived": "Archived chats",
      "unknown": "Unknown chats",
      "contacts": "Contacts",
      "campaigns": "Campaigns"
    },
    "send_templates_to_many": {
      "sendingTemplates": "Sending Templates...",
      "failedToSendTemplates": "Failed to send templates",
      "templatesSent": "Templates Sent",
      "failedToSendToChats": "Templates Sent\nFailed to send to - {{numberOfFailed}} clients"
    },
    "bulk_send": {
      "title": "Bulk Send Messages",
      "step_1_upload": "Upload Phone Numbers",
      "step_1_template": "Step 1: Select Template",
      "step_2_phone": "Step 2: Select Sender Phone",
      "step_2_options": "Options",
      "step_3_select_phone": "Select Phone",
      "step_3_csv": "Step 3: Upload CSV",
      "step_4_template": "Select Template",
      "step_4_media": "Step 4: Upload {{type}} Header",
      "instructions": "Upload a CSV file with phone numbers to send messages to.",
      "download_template": "Download CSV Template",
      "drop_csv": "Drop CSV file here or click to browse",
      "drop_media": "Drop {{type}} file here or click to browse",
      "phone_number": "Phone Number",
      "first_name": "First Name",
      "last_name": "Last Name",
      "preview": "Preview (showing first 5 rows)",
      "more_rows": "+{{count}} more rows",
      "add_to_contacts": "Add phone numbers to Contacts",
      "select_phone": "Select a phone number to send from",
      "select_template": "Select a template to send",
      "send_messages": "Send Messages",
      "create_campaign": "Create Campaign",
      "no_whatsapp_phones": "No WhatsApp phones available. Please configure a WhatsApp phone first.",
      "sending_messages": "Sending messages...",
      "all_messages_sent": "All {{count}} messages sent successfully!",
      "all_messages_failed": "Failed to send all messages",
      "partial_success": "{{successCount}} messages sent, {{failedCount}} failed",
      "send_failed": "Failed to send messages. Please try again.",
      "csv_errors": {
        "empty_file": "CSV file is empty",
        "missing_required_headers": "CSV file missing required headers: {{missingRequiredHeaders}}",
        "invalid_headers": "CSV file contains invalid headers: {{invalidHeaders}}",
        "invalid_phones": "CSV file contains invalid phone numbers: {{invalidPhones}}",
        "too_many_rows": "CSV file contains {{rowCount}} rows, but maximum allowed is {{maxRows}} rows",
        "missing_template_params": "CSV file missing template parameter columns: {{params}}"
      },
      "cancel": "Cancel",
      "required": "Required",
      "optional": "Optional",
      "phone_description": "All valid phone numbers will receive messages",
      "first_name_description": "Used for contact creation",
      "last_name_description": "Used for contact creation",
      "contact_note": "Note: Only entries with both First Name and Last Name will be added as contacts when \"Add to contacts\" is enabled.",
      "contacts_to_add": "{{count}} contacts will be added",
      "campaign_name": "Campaign Name",
      "campaign_name_placeholder": "Enter a name for this campaign",
      "media_type_mismatch": "Please upload a {{expected}} file",
      "summary": "Summary",
      "summary_rows": "{{count}} recipients",
      "summary_template": "Template: {{name}}",
      "summary_phone": "From: {{phone}}",
      "campaign_created": "Campaign created!",
      "campaign_error": "Failed to create campaign"
    },
    "campaigns": {
      "title": "Campaigns",
      "loading": "Loading campaigns...",
      "loading_items": "Loading items...",
      "no_campaigns": "No campaigns yet. Create a bulk send campaign to get started.",
      "no_items": "No items found",
      "no_search_results": "No campaigns match your search",
      "search_placeholder": "Search campaigns...",
      "select_campaign": "Select a campaign to view details",
      "back_to_list": "Back to campaigns",
      "back": "Back",
      "total": "Total",
      "success": "Success",
      "failed": "Failed",
      "pending": "Pending",
      "all": "All",
      "phone": "Phone",
      "first_name": "First Name",
      "last_name": "Last Name",
      "status": "Status",
      "error": "Error",
      "export": "Export",
      "template": "Template",
      "sender": "Sender",
      "created": "Created",
      "add_campaign_tooltip": "Add campaign"
    },
    "labels": {
      "add_labels": "Add labels",
      "select_contacts_to_add_labels": "Select contacts to add labels to",
      "modal": {
        "header": "select labels",
        "failed_to_add_labels_to_selected_chats": "Failed to add labels to selected chats",
        "succeed_to_add_labels_to_selected_chats": "Succeed to add labels to selected chats"
      }
    },
    "filters": {
      "all": "All",
      "unassigned": "Unassigned",
      "assigned_to_me": "Assigned to me"
    },
    "status": {
      "label": "Status",
      "open": "Open",
      "pending": "Pending",
      "bot": "Bot",
      "closed": "Closed",
      "update_success": "Status updated successfully",
      "update_failed": "Failed to update status"
    },
    "assign_agent": {
      "placeholder": "Assign agent...",
      "no_agents": "No agents available",
      "search_placeholder": "Search agents...",
      "assigned": "Assigned",
      "update_success": "Agent assignment updated",
      "update_failed": "Failed to update agent assignment"
    },
    "opt_in": {
      "send": {
        "message1": "You've initiated an opt-in request with the contact.",
        "message2": "Once the contact accepts, you'll gain the ability to start messaging."
      },
      "no_send": {
        "message1": "You haven't initiated an opt-in request with the contact yet.",
        "message2": "If you want to send opt-in template please click",
        "here": "here"
      },
      "modal": {
        "message1": "This action needs approval from the contact to start conversation through WhatsApp.",
        "message2": "Are you sure you want to send the opt-in request?",
        "template_name": "Template name:",
        "template_lang": "Template language:",
        "header": "Initiate Customer Opt-In",
        "send_template_header": "Select Template to send",
        "param_required": "This field is required",
        "param_too_long": "Maximum {{max}} characters allowed",
        "enter_param_value": "Enter value for {{{{index}}}}",
        "assign_conversation_to_me": "Assign conversation to me",
        "set_conversations_status_to_open": "Set conversation status to open",
        "image_header": "Image Header",
        "video_header": "Video Header",
        "document_header": "Document Header",
        "upload_image": "Upload image:",
        "upload_video": "Upload video:",
        "upload_document": "Upload document:",
        "drop_or_click": "Drag and drop or click to upload",
        "file_too_large": "File size exceeds the limit ({{maxSize}})",
        "invalid_file_type": "Invalid file type. Expected {{expected}}",
        "file_required": "Please upload a file for the media header"
      }
    },
    "add_contact_modal": {
      "add_contact_title": "Add contact",
      "edit_contact_title": "Edit contact"
    },
    "chat_list": {
      "header": "Chats",
      "add_chat_tooltip": "Select contact",
      "search_contact_placeholder": "Search name or phone...",
      "no_search_results": "No chats found",
      "no_contacts": "Click the '+' option to select or add contact and start chatting",
      "select_contact_to_send_template": "Select contacts to send template to",
      "cancel_select_contact_to_send_template": "Cancel contact selection",
      "add_contact_via_csv": "Add contact via CSV"
    },
    "select_contact_modal": {
      "title": "Select contact",
      "search_placeholder": "Search name or phone",
      "no_contact": "To begin chatting, click the '+' option to add contact.",
      "no_results": "We didn't find anything",
      "chat_from": "Chat from {{number}}"
    },
    "contact_list": {
      "header": "Chats",
      "add_contact_tooltip": "Add contact",
      "search_contact_placeholder": "Search name or phone...",
      "no_search_results": "No contacts found",
      "no_contacts": "Click the '+' option to add contact"
    },
    "message_panel": {
      "text_placeholder": "Type a message"
    },
    "configuration_missing_message1": "WhatsApp Business API configuration incomplete",
    "configuration_missing_message2": "Please contact your administrator to complete the setup",
    "smarters_token_missing_message1": "Smarters token is not configured",
    "smarters_token_missing_message2": "Please contact your administrator to configure the Smarters token for your WhatsApp Business API phone",
    "archive_contact": {
      "message1": "Are you sure you want to archive contact '{{name}}'?",
      "message1_multiple": "Are you sure you want to archive {{num_of_items}} contacts?",
      "message2": "Archiving will remove the contact from your active list. However, your past chat history will be preserved.",
      "archive": "Archive",
      "unarchive": "Unrchive",
      "unarchive_message": "Are you sure you want to unarchive contact '{{name}}'?",
      "title": "Archive contact"
    },
    "archive_chat": {
      "message1": "Are you sure you want to archive chat '{{name}}'?",
      "message1_multiple": "Are you sure you want to archive {{num_of_items}} chats?",
      "message2": "Archiving will remove the chat from your active list. However, your past chat history will be preserved.",
      "archive": "Archive",
      "unarchive": "Unrchive",
      "unarchive_message": "Are you sure you want to unarchive chat '{{name}}'?",
      "unarchive_message_multiple": "Are you sure you want to unarchive {{num_of_items}} chats?",
      "title": "Archive chat"
    },
    "add_to_contacts": "Add to contacts",
    "contact_details": "Contact details",
    "convert_unknown_contact": "Mark contact as known",
    "convert_unknown_contact_modal_message": "Are you sure you want to mark '{{name}}' to known?",
    "create_new_contact": "Create new contact",
    "add_to_existing_contact": "Add to existing contact",
    "chat_from_dialog": {
      "title": "Select channel to chat from"
    },
    "selected_chats": "Selected chats",
    "send_template": "Send Template",
    "send_location_permissions_decline": "Location permissions must be granted for sending location",
    "failed_to_import_contacts_from_csv": "Failed to import contacts from csv",
    "contacts_imported_successfully": "Contacts imported successfully"
  },
  "no_results": "No results",
  "waba_errors": {
    "title": "Message Delivery Failed",
    "unknown": "This message could not be delivered.",
    "generic_error": "Your message could not be delivered (Error {{errorCode}}).",
    "media_download_error": "The file type is not supported. Please try a different format.",
    "media_file_size_too_big": "The file size exceeds the limit. Please try a smaller file.",
    "media_type_not_supported": "The media type is not supported for this message type.",
    "media_download_failed": "Failed to download the media file. Please try again.",
    "rate_limit_hit": "Message was not delivered due to rate limiting. Please try again later.",
    "message_limit_exceeded": "You've exceeded the messaging limit for this phone number.",
    "business_restricted": "Business is restricted from sending messages.",
    "template_param_count_mismatch": "The number of template parameters does not match the template.",
    "template_not_found": "The template does not exist or has not been approved.",
    "template_content_mismatch": "Template content does not match the approved template.",
    "template_paused": "Template was paused due to low quality rating.",
    "template_disabled": "Template is disabled.",
    "template_params_invalid": "Template parameters are missing or invalid.",
    "template_quality_low": "Template quality is too low to send.",
    "invalid_recipient": "The recipient is not a valid WhatsApp user.",
    "recipient_not_in_allowed_list": "This phone number is not on the allowed list for your WhatsApp account.",
    "user_not_opted_in": "This message could not be delivered because the customer has not opted in.",
    "outside_24h_window": "Message failed to send because it was sent outside the 24-hour window.",
    "cloud_api_rate_limit": "WhatsApp Cloud API rate limit hit. Please try again later.",
    "internal_error": "Something went wrong on WhatsApp's servers. Please try again.",
    "access_denied": "Access denied. Please check permissions.",
    "account_locked": "Business account is locked or restricted.",
    "message_too_old": "Message failed to send. The message may be too old.",
    "message_type_not_supported": "Message type is not supported.",
    "recipient_blocked": "Recipient blocked messages from this business.",
    "required_parameter_missing": "A required parameter is missing from the request.",
    "parameter_value_invalid": "A parameter value is not valid.",
    "phone_number_not_registered": "The phone number is not registered for WhatsApp Business.",
    "unsupported_message": "This message type is not supported.",
    "display_name_approval_required": "Display name approval is required before sending messages.",
    "temporarily_unavailable": "WhatsApp is temporarily unavailable. Please try again later.",
    "user_experiment": "This message could not be sent due to a user experiment restriction.",
    "phone_number_reverification_needed": "Phone number re-verification is required.",
    "pair_rate_limit": "Too many messages were sent to this recipient in a short period. Please wait before trying again.",
    "healthy_ecosystem_engagement": "This message was not delivered by Meta to maintain a healthy ecosystem — the recipient recently received too many marketing messages. Please try again later.",
    "media_upload_failed": "Failed to upload the media file. It may be corrupted, unsupported, or too large.",
    "template_text_too_long": "The template message is too long after filling in the parameters.",
    "template_content_policy": "The template content violates WhatsApp's format or character policy.",
    "recipient_same_as_sender": "The recipient phone number cannot be the same as the sender phone number.",
    "payment_issue": "There is a payment issue with the WhatsApp Business account. Please check the billing settings.",
    "incorrect_certificate": "The phone number's registration certificate is missing or incorrect. Please re-register the phone number.",
    "account_maintenance": "The WhatsApp Business account is in maintenance mode. Please try again later."
  },
  "resend_message": {
    "message_not_synced": "Message has not synced yet, please try again in a few minutes",
    "message_file_not_found": "We could not find the message file, try to write a new message with the same file and text",
    "cannot_send_empty_text": "Cannot send text message without text",
    "cannot_resend_message": "Tuvis could not resend the message, please try again later",
    "resend_message": "Resend message",
    "confirm_resend_message": "Are you sure you want to resend this message?",
    "message_resent": "Message has been resent"
  }
}
